<div class="col-12" *ngIf="displayIsDuplicateLoader">
  <app-busy [message]="'Loading. Please wait...'"></app-busy>
</div>
<div class="container-fluid">
  <div class="row">
    <div style="margin-top:15px; margin-bottom:-10px;">
      <h4><span style="padding-right:10px"></span> <i class="fa fa-edit"></i><span id="procesHeader">{{processHeader}}</span> for <b><span id="carrierName">{{carrierNameNew}}</span></b>.<ng-container *ngIf="(duplicateApp || amendApp) && !(processHeader == 'Complete Payment')"> Permit: {{permitCode}} - {{permitNumber}}</ng-container>
      <ng-container *ngIf="viewPermitCount!=null && !isProcess">
         {{viewAppId}}
      </ng-container></h4>
    </div>
  </div>
  <hr />
  <div class="row" style="margin:0px;padding:0px;">
    <div class="col-12" style="margin:0px;padding:0px;" *ngIf="!viewPage">
      <div class="prx-nav" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
        <ul class="nav nav-pills nav-tabs nav-fill" role="tablist" style="margin:0px;padding:0px;">

          <!-- <li class="nav-item tb-siz" *ngIf="changeRouteTimetable&&utility.activeTab!=3"> -->
            <li class="nav-item tb-siz" *ngIf="this.dataCntrl.status == 2">
            <a class="nav-link text-left" (click)="onActive1(0)"  [ngClass]="{ 'active':utility.activeTab==0,'disabled':(utility.confirmCtrl==false)}">
              <span class="row">
                <span  class="col-12 centrer tab-hd"><strong></strong> Carrier Details</span>
              </span>
            </a>
          </li>

          <li class="nav-item tb-siz">
            <a class="nav-link text-left"   (click)="onActive1(1)" [ngClass]="{ 'active':utility.activeTab==1,'disabled':(utility.confirmCtrl==false)}">
              <span class="row">
                <span  class="col-12 centrer tab-hd"><strong *ngIf="!duplicateApp && !isReplaceVehicle && !isCorrectPermit">{{utility.sequenceNumbers.permitNum}}</strong> Permit Info</span>
              </span>
            </a>
          </li>
          <li class="nav-item tb-siz" >
            <a class="nav-link"   (click)="onActive1(2)" [ngClass]="{ 'active':utility.activeTab==2,'disabled':(utility.confirmCtrl==false)}">
              <span class="row" >
                <span  class="col-12 centrer tab-hd"><strong *ngIf="!duplicateApp && !isReplaceVehicle && !isCorrectPermit">{{utility.sequenceNumbers.vehicleNum}}</strong> Vehicles</span>
              </span>
            </a>
        </li>
          <li class="nav-item tb-siz" >
            <a class="nav-link"   (click)="onActive1(3)" [ngClass]="{ 'active':utility.activeTab==3,'disabled':(utility.confirmCtrl==false)}">
              <span class="row" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
              <span  class="col-12 centrer tab-hd"><strong *ngIf="!duplicateApp && !isReplaceVehicle && !isCorrectPermit">{{utility.sequenceNumbers.routesNum}}</strong> Routes</span>
              </span>
            </a>
          </li>

          <!--Motivation Tab-->
          <li class="nav-item tb-siz">
            <a class="nav-link"  (click)="onActive1(4)" [ngClass]="{ 'active':utility.activeTab==4,'disabled':(utility.confirmCtrl==false)}">
              <span class="row" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
                <span class="col-12 centrer tab-hd"><strong *ngIf="!duplicateApp && !isReplaceVehicle && !isCorrectPermit">{{orderTabSequence(utility.timetableActive,utility.sequenceNumbers.motivationNum)}}</strong> Motivation</span>
              </span>
            </a>
          </li>
          <!--End Motivation Tab-->
          <li class="nav-item tb-siz" *ngIf="utility.timetableActive">
            <a class="nav-link"   (click)="onActive1(orderTabSequence(utility.timetableActive,utility.sequenceNumbers.timeTableNum))" [ngClass]="{ 'active':(utility.timetableActive)?utility.activeTab==5 : utility.activeTab==5,'disabled':(utility.confirmCtrl==false)}">
              <span class="row" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
              <span  class="col-12 centrer tab-hd"><strong *ngIf="!duplicateApp && !isReplaceVehicle && !isCorrectPermit">{{utility.sequenceNumbers.timeTableNum}}</strong> Timetable</span>
              </span>
            </a>
          </li>
          <li class="nav-item tb-siz">
            <a class="nav-link"   (click)="onActive1(orderTabSequence(utility.timetableActive,utility.sequenceNumbers.uploadsNum))" [ngClass]="{ 'active':(utility.timetableActive)?utility.activeTab==6 : utility.activeTab==5,'disabled':(utility.confirmCtrl==false)}">
              <span class="row" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
              <span  class="col-12 centrer tab-hd"><strong *ngIf="!duplicateApp && !isReplaceVehicle && !isCorrectPermit">{{orderTabSequence(utility.timetableActive,utility.sequenceNumbers.uploadsNum)}}</strong> Uploads</span>
              </span>
            </a>
          </li>
          <li class="nav-item tb-siz">
            <a class="nav-link"   (click)="onActive1(orderTabSequence(utility.timetableActive,utility.sequenceNumbers.cnfNum))" [ngClass]="{ 'active':(utility.timetableActive)?utility.activeTab==7 : utility.activeTab==6,'disabled':(utility.confirmCtrl==true && utility.dontAllowConfirm)}">
              <span class="row" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
              <span  class="col-12 centrer tab-hd"><strong *ngIf="!duplicateApp && !isReplaceVehicle && !isCorrectPermit">{{orderTabSequence(utility.timetableActive,utility.sequenceNumbers.cnfNum)}}</strong> Confirmation</span>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12" style="margin:0px;padding:0px;">
      <div class="tab-content" style="margin-top:20px;width:100%;">

        <div *ngIf="isProcess">
          <div class="container-fluid">
            <div class="row" style="margin:0px;padding:0px;">
              <div class="col-12" style="margin:0px;padding:0px;">
                <div class="btn-group btn-style" dropdown>
                  <button id="button-basic" (click)="showMenu('dropdown-basic')" type="button" class="btn btn-primary dropdown-toggle"
                          aria-controls="dropdown-basic">
                    Select Actions <span class="caret"></span>
                  </button>
                  <ul id="dropdown-basic" *ngIf="showMenuBtn" class="dropdown-menu dropdown-list" style="display:block"
                      role="menu" aria-labelledby="button-basic">
                    <li role="menuitem"><a class="dropdown-item" (click)="cancel()" href="javascript:void(0)">Cancel</a></li>
                    <li role="menuitem"><a class="dropdown-item" [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Additional Info</a></li>
                    <li role="menuitem"><a class="dropdown-item" [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Approve</a></li>

                    <li role="menuitem">
                      <a class="dropdown-item" [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Escalate</a>
                    </li>
                    <li role="menuitem">
                      <a class="dropdown-item" [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Update</a>
                    </li>
                    <li role="menuitem">
                      <a class="dropdown-item" [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Change Status</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-doc" *ngIf="utility.activeTab==0" [ngClass]="{ 'active':utility.activeTab==0}">
          <div class="row">
            <div class="col-12" style="margin-top:20px!important;" *ngIf="utility.activeTab==0">
              <app-carrier-details [dataCntrl]="dataCntrl"></app-carrier-details>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-info" [ngClass]="{ 'active':utility.activeTab==1, 'hide-permit-type': displayIsDuplicateLoader}" *ngIf="utility.activeTab==1">
          <div class="row">
            <div class="col-12 mk-space" *ngIf="utility.activeTab==1">
              <app-app-permit-type [dataCntrl]="dataCntrl"></app-app-permit-type>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-doc" *ngIf="utility.activeTab==2" [ngClass]="{ 'active':utility.activeTab==2}">
          <div class="row">
            <div class="col-12" style="margin-top:20px!important;" *ngIf="utility.activeTab==2">
              <app-app-vehicle [dataCntrl]="dataCntrl"></app-app-vehicle>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-conf" *ngIf="utility.activeTab==3" [ngClass]="{ 'active':utility.activeTab==3}">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12" *ngIf="utility.activeTab==3">
              <app-app-route [dataCntrl]="dataCntrl"></app-app-route>
            </div>
          </div>
        </div>
        <div *ngIf="utility.activeTab==4" class="tab-pane mk-frm" id="car-conf"  [ngClass]="{ 'active':utility.activeTab==4}">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12" *ngIf="utility.activeTab==4">
              <app-app-motivation [dataCntrl]="dataCntrl"></app-app-motivation>
            </div>
          </div>
        </div>
        <!--Motivation Content-->
        <div class="tab-pane mk-frm" id="car-conf" *ngIf="(utility.timetableActive)?utility.activeTab==5:utility.activeTab==4" [ngClass]="{ 'active':(utility.timetableActive)?utility.activeTab==5:utility.activeTab==4}">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12" *ngIf="(utility.timetableActive)?utility.activeTab==5:utility.activeTab==5">
              <app-timetable [dataCntrl]="dataCntrl"></app-timetable>
            </div>
          </div>
        </div>
        <!--End Motivation Content-->
        <div class="tab-pane mk-frm" id="car-conf" *ngIf="(utility.timetableActive)?utility.activeTab==6:utility.activeTab==5" [ngClass]="{ 'active':(utility.timetableActive)?utility.activeTab==6:utility.activeTab==5}">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12" *ngIf="(utility.timetableActive)?utility.activeTab==6:utility.activeTab==5">
              <app-app-uploads isPermitDoc="true" [dataCntrl]="dataCntrl"></app-app-uploads>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-conf" *ngIf="(utility.timetableActive)?utility.activeTab==7:utility.activeTab==6" [ngClass]="{ 'active':(utility.timetableActive)?utility.activeTab==7:utility.activeTab==6}">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12" *ngIf="(utility.timetableActive)?utility.activeTab==7:utility.activeTab==6 && showPage">
              <app-confirmation [dataCntrl]="dataCntrl"></app-confirmation>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- <button
        class="btn btn-md m-clr pull-right hd-btn"  style="float: right !important;" (click)="onActive(2)">
        <i class="fa fa-save" ></i> Save & Continue</button> -->
</div>
